import ActivityFeedProvider from "./ActivityFeedProvider";

export { ActivityFeedProvider as default };
